/**
 * Actividad
 *
 */
import React from 'react'
import { Tag, Typography, Progress, Icon } from 'antd'
import numeral from 'numeral'

const styles = {
  root: {
    cursor: 'pointer',
  },

  content: {
    padding: 13,
  },

  codigo: {
    margin: 0,
  },

  descripcion: {},

  um: {
    marginRight: 5,
  },

  cantidad: {
    marginRight: 5,
  },

  importe: {
    marginRight: 5,
  },
}

export class Actividad extends React.PureComponent {
  /**
   * Render
   *
   */
  render() {
    const tieneAvance = this.props.volumenAvance > 0
    const completed = this.props.porcentajeAvance >= 1
    const inProgress = !completed && this.props.porcentajeAvance > 0
    const status = completed ? 'success' : (
      inProgress ? 'active' : 'normal'
    )

    const medida = (
      <span style={styles.um}>{this.props.medida}</span>
    )

    return (
      <div style={styles.root} onClick={this.props.onClick}>
        <div style={styles.content}>
          <div>
            <Typography.Title level={4} style={styles.codigo}>{this.props.actividad}</Typography.Title>
            <Typography.Text style={styles.codigo}>
              <span style={styles.importe}>{numeral(this.props.cantidad * this.props.precio).format('$0,0.00')}</span>
            </Typography.Text>
          </div>

          <Typography.Paragraph ellipsis={{ expandable: false, rows: 2 }} style={styles.descripcion}>{this.props.descripcion}</Typography.Paragraph>

          <label>
            <span style={styles.cantidad}>AV {numeral(this.props.volumenAvance).format('0,0.00')}</span>
            <span style={{ marginRight: 3 }}>DE</span>
            <span style={styles.cantidad}>{numeral(this.props.cantidad).format('0,0.00')}</span>
            {medida}
          </label>

          {tieneAvance ? (
            <Progress
              type='line'
              size='small'
              status={status}
              percent={this.props.porcentajeAvance * 100}
              showInfo={false}
              strokeWidth={3}
            />
          ) : null}

          <div style={styles.tags}>
            {tieneAvance ? (
              <Tag color={inProgress ? 'blue' : 'success'} children={
                <span>
                  <span>{numeral(this.props.porcentajeAvance).format('0,0.00%')}</span>
                  <Icon type='thunderbolt' style={{ marginLeft: 3, color: 'inherit' }} />
                </span>
              } />
            ) : null}
            {this.props.cobroCompletado ? (<Tag color='green' children='COBRADO' />) : null}
          </div>
        </div>
      </div>
    )
  }
}
